import React, { Fragment } from 'react'
import { Marker as ReactMarker, InfoWindow, Polygon, Rectangle, Polyline } from 'react-google-maps'
import Tank from 'components/Page/Home/Tank'
import { PINCOLORS } from 'utils/constants'

interface IProps {
  loc: any
  disabled?: boolean
  onClick?: (tankId: string) => void
  geoZoneSelected?
}

interface IState {
  openInfoWindow: boolean
}

class Marker extends React.PureComponent<IProps, IState> {
  static defaultProps = {
    onClick: () => { },
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      openInfoWindow: false
    }
  }

  onMarkerClick = () => {
    const { disabled } = this.props
    if (!disabled) {
      this.onToggleOpen()
    }
  }

  onToggleOpen = () =>
    this.setState({
      openInfoWindow: !this.state.openInfoWindow,
    })

  pinSymbol = (color) => {
    return {
      path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#000',
      strokeWeight: 2,
      scale: 1
    };
  }

  render() {
    const { loc, onClick, geoZoneSelected } = this.props
    const { openInfoWindow } = this.state
    var fillColor;
    fillColor = PINCOLORS.get(loc.tank.product);
    // var icon = {
    //   path: 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z',
    //   fillColor: fillColor,
    //   fillOpacity: 1,
    //   anchor: new google.maps.Point(0, 0),
    //   strokeWeight: 1,
    //   scale: 1.2
    // }

    // const icon = {
    //   url: animatedGif,
    //   scaledSize: new window.google.maps.Size(50, 50),
    // };

		var icon = {
		  url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
		  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg"
       width="256" height="256" xml:space="preserve"><switch><g>
       <g stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
       <ellipse fill="${fillColor}" stroke="#EE5325" cx="127.75" cy="188.75" rx="26.25" ry="6.25"/>
       <path fill="red" stroke="blue" d="M136.39 175.645c28.758.983 50.86 6.873 50.86 13.992 0 7.809-26.583 14.137-59.375 14.137S68.5 197.445 68.5 189.637c0-2.321 2.349-4.512 6.512-6.443 8.643-4.012 25.103-6.91 44.592-7.557"/>
       <path fill="none" stroke="#F9B618"
        d="M139.886 170.266c36.05 1.623 63.614 10.512 63.614 21.234 0 11.874-33.803 21.5-75.5 21.5s-75.5-9.626-75.5-21.5c0-10.723 27.564-19.611 63.614-21.234"/>
       <path fill="${fillColor}" stroke="${fillColor}" 
       d="M176.75 91.75c0 26.924-48.75 96.335-48.75 96.335S79.25 118.674 79.25 91.75 101.076 43 128 43s48.75 21.826 48.75 48.75z"/>
       <circle fill="#FFF" stroke="#BABABA" cx="128" cy="90.96" r="20.909"/></g></g></switch></svg>
		`),
		 scaledSize: new window.google.maps.Size(60, 80),
		}
    var isWithinPolygon = true;
    if (geoZoneSelected !== undefined) {
      var geoFencingZonesFilter = localStorage.getItem('geoFencingZonesStorage');
      var locationLatLng;
      var polygons = [];
      for (var i = 0; i < JSON.parse(geoFencingZonesFilter).length; i++) {
        var zoneFromDB = JSON.parse(geoFencingZonesFilter)[i].zonename;
        if (geoZoneSelected.includes(zoneFromDB)) {
          var fdata = JSON.stringify(JSON.parse(geoFencingZonesFilter)[i].location);
          locationLatLng = JSON.parse(fdata).map(function (o) {
            var d = o.split(',').map(function (b) {
              return Number(b.replace(/(}|{id:|lat:|lng:)/g, ''));
            });
            return {
              lat: d[1],
              lng: d[2]
            };
          });
          polygons.push(locationLatLng);
        }
      }
      // var yourPolygon = new google.maps.Polygon({
      //   //paths: obj.location
      //   paths: locationTest
      // });
      // var coordinate = new google.maps.LatLng(loc.latitude, loc.longitude);
      // var isExistCount = 0;
      // for (var i = 0; i < polygons.length; i++) {
      //   var yourPolygon = new google.maps.Polygon({
      //     paths: polygons[i][0]
      //   });
      //   isWithinPolygon = google.maps.geometry.poly.containsLocation(coordinate, yourPolygon);
      //   if (isWithinPolygon == true) {
      //     isExistCount = isExistCount + 1;
      //     alert('found');
      //   }
      // }
      // isWithinPolygon = google.maps.geometry.poly.containsLocation(coordinate, yourPolygon);
      //}
    }
  
      return (
        <Fragment>
          <ReactMarker position={{ lat: Number(loc.latitude), lng: Number(loc.longitude) }} icon={icon} title={loc.tank.deviceID} onClick={this.onMarkerClick}>
            {openInfoWindow && (
              <InfoWindow onCloseClick={this.onToggleOpen}>
                <div style={{ width: '300px' }}>
                  <Tank tank={loc.tank} onClick={() => onClick(loc.tank.deviceID)} />
                </div>
              </InfoWindow>
            )}
          </ReactMarker>

          <Polygon
            paths={polygons}
            options={{
              strokeColor: "red",
              strokeOpacity: 1,
              strokeWeight: 2,
              fillColor: "#C1C1C1"

            }}
          />
        </Fragment>
      )
    //}
  }
}
export default Marker
